import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/Home';
import mainStore from '../MainStore';
import AuthStore from './Auth/AuthStore';
import ProjectKanban from '../components/Controls/Projects/ProjectKanban';

export default class Home extends Component {
    constructor() {
        super();

        if (AuthStore.getIsPortal) document.location.replace('/portal');

        this.state = {
        };

        this.handleCreateProjectClick = this.handleCreateProjectClick.bind(this);
    };

    componentDidMount() {
    };

    handleCreateProjectClick() {
        mainStore.openProjectDialog({ name: this.state.projectName });
        //this.setState({ isProjectDialogOpen: true, project: { name: this.state.projectName } });
    }

    render() {
        return (
            <div className="project-main">
                fff
                <ProjectKanban />
            </div>

        );
    }
}



